import { type OrderItemConfigurationSchema } from "@/components/OrderItemConfigForm/OrderItemConfigForm.schema";

/**
 * Transforms form data to update command payload
 *
 * This utility handles the complex transformation logic from the form schema
 * to the API update command format.
 */
export const transformFormDataToUpdateCommand = (
  data: OrderItemConfigurationSchema
) => {
  const { deliveryDate, dispatchFiles, preMediaFiles, versions, ...rest } =
    data;

  const getFilteredDispatchFiles = () => {
    const filtered = dispatchFiles?.filter((file) => !!file.fileSignedId);
    return filtered && filtered.length > 0 ? filtered : undefined;
  };

  return {
    ...rest,
    SandboxItemPreMediaFiles: preMediaFiles?.some(
      (file) => file.isDeleted || !!file.fileSignedId
    )
      ? preMediaFiles.filter((file) => file.isDeleted || !!file.fileSignedId)
      : undefined,
    sandboxItemVersion: versions.map((version) => ({
      id: version.id,
      isDeleted: version.isDeleted,
      isHDFileDeleted: version.isHDFileDeleted,
      name: version.name,
      blobId: version.blobId,
      fileSignedId: version.fileSignedId,
      sandboxItemVersionDispatch: version.dispatches.map((dispatch) => ({
        quantity: dispatch.quantity,
        address: {
          address: dispatch.address.address,
          city: dispatch.address.city,
          country: dispatch.address.country,
          id: dispatch.address.id,
          name: dispatch.address.name,
          phoneNumber: dispatch.address.phoneNumber,
          postalCode: dispatch.address.postalCode,
          complementaryInfo: dispatch.address.complementaryInfo,
          recipientName: dispatch.address.recipientName,
        },
      })),
    })),
    dispatchFiles: getFilteredDispatchFiles(),
    deliveryDate: deliveryDate
      ? new Date(deliveryDate).toISOString()
      : undefined,
  };
};
